import React from 'react'
import { Link } from 'react-static'

import arrow from '../../images/icons/arrow-left.png'

const BackArrow = () => (
  <Link to="/" className="back-arrow">
    <img src={arrow} alt="go back" />
  </Link>
)

export default BackArrow



// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/BackArrow.js